{
  "alert": "Alerta",
  "dismiss": "Descartar"
}